import { ElementsArray } from 'polotno/model/group-model';

export function unlockElements(elements: ElementsArray) {
    elements.forEach(element => {
        element.set({
            draggable: true,
            contentEditable: true,
            styleEditable: true,
            resizable: true,
            removable: true,
        });
    });
}
